import { RcClasses } from '../../../foundation';
export var RcAccordionClasses = RcClasses(['expanded', 'root'], 'RcAccordion');
